module.exports = __webpack_public_path__ + "img/success-icon.fe27cb7e.png";